(function($) {
    $(() => {
        if (window.matchMedia('(min-width: 768px)').matches) {
            // TABLET / DESKTOP / ABOVE
            $('.jarallax').jarallax();
        }

        const jarallaxWatermarked = $('.jarallax-watermarked');
        switch (true) {
            case window.matchMedia('(min-width: 1600px)').matches:
                // DESKTOP / ABOVE
                jarallaxWatermarked.jarallax({
                    speed: 0.8,
                    imgPosition: 'top 280px center',
                    imgSize: '1500px auto'
                });
                break;
            case window.matchMedia('(min-width: 768px)').matches:
                // TABLET / DESKTOP
                jarallaxWatermarked.jarallax({
                    speed: 0.9,
                    imgPosition: 'top 200px center',
                    imgSize: '75% auto'
                });
                break;
            default:
                // MOBILE
                jarallaxWatermarked.jarallax({
                    speed: 0.95,
                    imgPosition: 'top 120px center',
                    imgSize: '90% auto'
                });
                break;
        }
    });
})(jQuery);
